import React from 'react';
import PropTypes from 'prop-types';

const ProgressCircle = ({ size, percentage }) => {
  const circleStyle = {
    width: size,
    height: size,
    position: 'relative',
    borderRadius: '50%',
    background: 'linear-gradient(transparent 0%, transparent 100%)',
  };

  const outerBorderStyle = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    border: '6px solid #ccc', // Outer border color
    borderRadius: '50%',
  };

  const innerBorderStyle = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    border: '6px solid  rgba(21, 101, 99, 1)',// Inner border color
    borderRadius: '50%',
    clipPath: percentage === 0 ? 'polygon(0% 0%, 0% 0%, 0% 0%)' : `polygon(0% 0%, 100% 0%, 100% ${100 - percentage}%, 0% 0%)`,
  };

  const textStyle = {
    fontSize: `${size / 4}px`,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  };

  return (
    <div className="progress-circle" style={circleStyle}>
      <div className="outer-border" style={outerBorderStyle}></div>
      <div className="inner-border" style={innerBorderStyle}></div>
      <div className="text" style={textStyle}>
        {percentage}%
      </div>
    </div>
  );
};

ProgressCircle.propTypes = {
  size: PropTypes.string,
  percentage: PropTypes.number.isRequired,
};

ProgressCircle.defaultProps = {
  size: '100px',
};

export default ProgressCircle;